import gsap from 'gsap'
import SplitType from 'split-type'
import store from '../util/store';

export class LinesFill {
  constructor(el) {
    this.el = el
    this.linesFull = []

    this.init()

    if (!store.detect.isMobile) {
      this._animate()
    }
  }

  init() {
    this.lines = new SplitType(this.el, { types: 'lines' }).lines

    this.lines.forEach((line) => {
      const lineText = line.innerHTML
      const lineFaded = document.createElement('div')
      const lineFull = document.createElement('div')

      lineFaded.classList.add('line__faded')
      lineFaded.innerHTML = lineText

      lineFull.classList.add('line__full')
      lineFull.innerHTML = lineText

      line.innerHTML = ''
      line.appendChild(lineFaded)
      line.appendChild(lineFull)

      this.linesFull.push(lineFull)
    })
  }

  _animate() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
        scrub: true,
        start: 'top bottom-=120',
        end: 'center center'
      }
    })

    this.linesFull.forEach((line) => {
      gsap.set(line, {
        clipPath: 'inset(0% 100% 0% 0%)'
      })

      tl.to(line, {
        clipPath: 'inset(0% 0% 0% 0%)'
      })
    })
  }
}

export default function createLinesFill(config) {
  return new LinesFill(config)
}
